





















































import NoUiSlider from '@/components/NoUISlider.vue'
import MultiSelectButtons from '@/components/MultiSelectButtons.vue'
import PreQualCheckList from '@/components/PQCheckList.vue'
import A from '@/utilities/alpha'
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as db from '@shared/types/database'

@Component({
  components: {
    NoUiSlider,
    MultiSelectButtons,
    PreQualCheckList
  }
})
export default class AudiencePrequalList extends Vue {
  @Prop({ required: true }) readonly selectedCriteria!: string[]
  @Prop({ required: true }) readonly preQualificationTypes!: any
  @Prop({ required: false, default: () => ({}) }) readonly audience: any
  @Prop({ required: true }) readonly errors!: any

  checkBoxFilter = [
    'Australia',
    'Belgium',
    'Canada',
    'Denmark',
    'Finland',
    'Germany',
    'Great Britain (UK)',
    'Hong Kong',
    'India',
    'Ireland',
    'Norway',
    'Singapore',
    'Sweden'
  ]

  initialAudience = A.clone(this.audience)

  get initialValues () {
    return this.getInitialValues(this.audience)
  }

  getInitialValues (audience: any): Record<string, db.Audience> {
    return audience ? this.selectedCriteria.reduce((acc, criterion) => {
      acc[criterion] = this.getInitialValue(audience, criterion)
      return acc
    }, {} as Record<string, any>) : {}
  }

  updatePrequal (prequal: string, values: any) {
    if (typeof values === 'string') {
      values = values.trim()
    }
    this.$emit('updatePrequal', {
      prequal: prequal,
      values: values
    })
  }

  getInitialValue (audience: any, criteria: string) {
    let initValues: number[] = []
    if (!audience[criteria]) return initValues
    if (this.preQualificationTypes[criteria].type === 'slider') {
      const first = parseInt(audience[criteria][0])
      const last = parseInt(audience[criteria][audience[criteria].length - 1])
      initValues = [first, last]
    } else {
      initValues = audience[criteria]
    }

    this.updatePrequal(criteria, initValues)
    return initValues
  }
}
